import { render, staticRenderFns } from "./QIcon.vue?vue&type=template&id=d942390e"
import script from "./QIcon.vue?vue&type=script&lang=js"
export * from "./QIcon.vue?vue&type=script&lang=js"
import style0 from "./QIcon.vue?vue&type=style&index=0&id=d942390e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports